import { useEffect, useState } from "react";

// Captura `beforeinstallprompt` (Chrome/Edge/Android) e expõe handler `instalar()`.
// Em iOS Safari não há evento — `podeInstalar` fica false e o usuário precisa
// usar "Adicionar à tela inicial" pelo menu de compartilhar.
//
// O Chrome dispara o evento UMA vez, logo no início. Quem monta depois (menu
// lateral, Configurações) perderia o evento — por isso ele é guardado no
// módulo, e o hook começa já com ele em mãos.
let eventoGuardado = null;
if (typeof window !== "undefined") {
  window.addEventListener('beforeinstallprompt', (e) => { e.preventDefault(); eventoGuardado = e; });
  window.addEventListener('appinstalled', () => { eventoGuardado = null; });
}

export const useInstallPrompt = () => {
  const [evento, setEvento] = useState(() => eventoGuardado);
  const [instalado, setInstalado] = useState(false);

  useEffect(() => {
    const handler = (e) => { e.preventDefault(); eventoGuardado = e; setEvento(e); };
    window.addEventListener('beforeinstallprompt', handler);
    const onInstalled = () => { setInstalado(true); setEvento(null); };
    window.addEventListener('appinstalled', onInstalled);
    if (window.matchMedia?.('(display-mode: standalone)')?.matches) setInstalado(true);
    return () => {
      window.removeEventListener('beforeinstallprompt', handler);
      window.removeEventListener('appinstalled', onInstalled);
    };
  }, []);

  const instalar = async () => {
    if (!evento) return false;
    evento.prompt();
    const escolha = await evento.userChoice;
    // O evento só serve uma vez, aceito ou recusado.
    eventoGuardado = null;
    setEvento(null);
    return escolha?.outcome === 'accepted';
  };

  return { podeInstalar: !!evento && !instalado, instalado, instalar };
};
